import { Component, ElementRef, Input } from '@angular/core';
import { AnswerRatingService } from '../../services/answer-rating/answer-rating.service';
import { IMessage, Rating } from 'src/app/interfaces/message.interface';

@Component({
  selector: 'app-answer-rating',
  templateUrl: './answer-rating.component.html',
  styleUrls: ['./answer-rating.component.scss'],
})
export class AnswerRatingComponent {
  @Input() public message!: IMessage;
  @Input() public chatEntriesContainer!: HTMLDivElement;

  constructor(
    private arService: AnswerRatingService,
    private elRef: ElementRef
  ) {}

  public thumbsUp(): void {
    if (this.message.rating === Rating.POSITIVE) {
      this.setRating(Rating.RESET);
    } else {
      this.setRating(Rating.POSITIVE);
    }
  }

  public thumbsDown(): void {
    if (this.message.rating === Rating.NEGATIVE) {
      this.setRating(Rating.RESET);
    } else {
      this.setRating(Rating.NEGATIVE);
    }
  }

  /** 
   * Sets the rating on the message, triggers service-method to persist the rating
   * and shows the negative feedback message if the rating is negative.
   */
  private async setRating(rating: Rating) {
    await this.arService.updateAnswerRating(this.message, rating);
    this.scrollThumbsButtons();
    this.message.showHumanAssistanceMessage = this.message.rating === Rating.NEGATIVE;
  }

  /**
   * This method scrolls the view, so that the thumbs-buttons are still under the mouse-cursor after the rating is set.
   */
  private scrollThumbsButtons(): void {
    const containerHeight = this.chatEntriesContainer.scrollHeight;
    const isScrolledToBottom = this.chatEntriesContainer.scrollHeight - this.chatEntriesContainer.clientHeight <= this.chatEntriesContainer.scrollTop + 1;
    setTimeout(() => {
      this.elRef.nativeElement.querySelector('.thumbs-down').offsetTop;
      const newContainerHeight = this.chatEntriesContainer.scrollHeight;
      const delta = newContainerHeight - containerHeight;
      if (!isScrolledToBottom || delta > 0) {
        this.chatEntriesContainer.scrollTop += delta;
      }
    }, 1);
  }
}
